import { apiUrl } from 'libs/apiUrl';
import fetch from "libs/fetchWithAuth";

const _baseUrl = apiUrl('/api/ext/spell-check');

class SpellCheck {
	static query(data, req) {
		return fetch(_baseUrl, {
			method: 'POST',
			body: JSON.stringify(data),
		}, req);
	}

	static addToDictionary(data, req) {
		return fetch(_baseUrl + '/add-to-dictionary', {
			method: 'POST',
			body: JSON.stringify(data),
		}, req);
	}

	static addToIgnoreList(data, req) {
		return fetch(_baseUrl + '/add-to-ignore-list', {
			method: 'POST',
			body: JSON.stringify(data),
		}, req);
	}

	static checkHealth(data, req) {
		return fetch(_baseUrl + '/check-health', {
			method: 'POST',
			body: JSON.stringify(data),
		}, req);
	}

	static langExist(data, req) {
		return fetch(_baseUrl + '/spellang', {
			method: 'POST',
			body: JSON.stringify(data),
		}, req);
	}
}

export default SpellCheck;
